import React, { useMemo, useState } from "react";
import { Form, withFormik } from "formik";
import { useTranslation } from "react-i18next";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import { Button, Menu, MenuItem, TextField, Tooltip } from "@material-ui/core";
import PublishIcon from "@material-ui/icons/Publish";
import GetAppIcon from "@material-ui/icons/GetApp";
import SaveIcon from "@material-ui/icons/Save";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { flatten, uniq } from "ramda";
import LoadingCircleView from "../LoadingCircleView";
import ReactTable from "react-table";
import DivCenter from "../../components/styled-components/DivCenter";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import { Autocomplete } from "@material-ui/lab";
import TagsInput from "react-tagsinput";
import Autosuggest from "react-autosuggest";
import { defaultTheme } from "react-autosuggest/dist/theme";
import history from "../../utils/history";
import ButtonComponent from "components/Button";
// import Papa from "papaparse";
import ObjectEditConfirmationModal from "../../modals/ObjectEditConfirmModal";

const formatSelectOptions = (elementArray) => {
  return elementArray.map((element) => ({
    value: element._id.toString(),
    label: element.email,
  }));
};

const UsersAssginedView = ({
  elementsList,
  loadingElementsList,
  usersMobile,
  assignedUsers,
  values,
  setFieldValue,
  saveUseersAssigned,
  processRelationshipName,
}) => {
  const { t } = useTranslation("processRelationship");
  const [anchorEl, setAnchorEl] = useState(null);
  const [objectChangedValues, setObjectChangedValues] = useState([]);
  const [open, setOpen] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const filterElement = (filter, row) => {
    const id = filter.pivotId || filter.id;

    if (typeof row[id] === "number") {
      row[id] = row[id].toString();
    }

    return row[id] !== undefined
      ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
      : true;
  };

  const optionsPagination = useMemo(() => {
    const count = Math.round(elementsList.length / 30);

    return Array.from(
      [...new Array(count).keys()],
      (element) => (element + 1) * parseInt(50)
    );
  }, [elementsList]);

  const usersFormat = formatSelectOptions(usersMobile);

  const { relations } = values;

  const columns = useMemo(() => {
    return [
      {
        Header: <DivCenter>Elemento</DivCenter>,
        accessor: "value",
        filterable: true,
        sortable: false,
        style: {
          textAlign: "center",
          whiteSpace: "break-spaces",
          fontSize: "18px",
        },
      },
      {
        Header: <DivCenter>Usuario</DivCenter>,
        accessor: "user",
        filterable: false,
        sortable: false,
        Cell: ({ original }) => {
          const { relations } = values;
          const elementFind = relations.find(
            (relation) =>
              relation?.elementId?.toString() === original?._id?.toString()
          );

          const selectedUser =
            elementFind &&
            usersFormat.find(
              (u) =>
                u.value ===
                (elementFind.userId ? elementFind.userId.toString() : "")
            );

          if (!usersMobile || usersMobile.length === 0) {
            return <span style={{ color: "#aaa" }}>Sin usuarios</span>;
          }
          return (
            <Autocomplete
              id="combo-box-demo"
              options={usersFormat}
              getOptionLabel={(option) => option.label || ""}
              value={selectedUser || null}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" />
              )}
              onChange={(event, item) => {
                // handleSelectChange(item, original);

                const index = relations.findIndex(
                  (relation) => relation.elementId === original._id
                );

                const oldRelation = relations.find(
                  (relation) => relation.elementId === original._id
                );

                if (!item || !item.value) {
                  setFieldValue(`relations.${index}.userId`, item);
                }else if (index !== -1) {
                  setFieldValue(`relations.${index}.userId`, item.value);
                } else {
                  setFieldValue(`relations`, [
                    ...relations,
                    {
                      elementId: original._id,
                      label: original.value,
                      userId: item.value,
                      tags: [],
                    },
                  ]);
                }

                const oldUser = usersFormat.find(
                  (user) => user.value === oldRelation?.userId
                );

                const objectModified = {
                  elementId: original?._id || "N/A",
                  elementName: original?.value || "N/A",
                  userId: item?.value || "N/A",
                  userEmail: item?.label || "N/A",
                  oldUserEmail: oldUser ? oldUser?.label : "N/A",
                };
                upsertObjectModified(objectModified);
              }}
            />
          );
        },
      },
      {
        Header: <DivCenter>Tags</DivCenter>,
        accessor: "tag",
        filterable: false,
        sortable: false,
        style: { textAlign: "center", whiteSpace: "break-spaces" },
        Cell: ({ original }) => {
          const { relations, currentTags } = values;
          const tagsFind = relations.find(
            (relation) =>
              relation?.elementId?.toString() === original?._id?.toString()
          );

          const index = relations.findIndex(
            (relation) => relation.elementId === original._id
          );

          return (
            <TagsInput
              value={tagsFind ? tagsFind.tags : []}
              onChange={(values) => {
                const newElements = values.filter(
                  (value) => !currentTags.includes(value)
                );

                if (index !== -1) {
                  setFieldValue(`relations.${index}.tags`, [...values]);
                } else {
                  setFieldValue(`relations`, [
                    ...relations,
                    {
                      elementId: original._id,
                      label: original.value,
                      userId: undefined,
                      tags: [...values],
                    },
                  ]);
                }

                setFieldValue(`currentTags`, [...currentTags, ...newElements]);
              }}
              onlyUnique={true}
              tagProps={{ className: "react-tagsinput-tag info" }}
              inputProps={{
                placeholder: "tags",
              }}
              renderInput={({ addTag, ...props }) => {
                const handleOnChange = (e, { newValue, method }) => {
                  if (method === "enter") {
                    e.preventDefault();
                  } else {
                    props.onChange(e);
                  }
                };

                const inputValue =
                  (props.value && props.value.trim().toLowerCase()) || "";
                const inputLength = inputValue.length;

                let suggestions = currentTags.filter((tag) => {
                  return tag.toLowerCase().slice(0, inputLength) === inputValue;
                });

                return (
                  <Autosuggest
                    ref={props.ref}
                    suggestions={suggestions}
                    shouldRenderSuggestions={(value) =>
                      value && value.trim().length > 0
                    }
                    getSuggestionValue={(suggestion) => suggestion}
                    renderSuggestion={(suggestion) => <span>{suggestion}</span>}
                    inputProps={{
                      ...props,
                      onChange: handleOnChange,
                    }}
                    onSuggestionSelected={(e, { suggestion }) => {
                      addTag(suggestion);
                    }}
                    onSuggestionsClearRequested={() => {}}
                    onSuggestionsFetchRequested={() => {}}
                    theme={{
                      ...defaultTheme,
                      container: "react-autosuggest__container_block",
                    }}
                  />
                );
              }}
            />
          );
        },
      },
    ];
  }, [relations, usersMobile]);

  const upsertObjectModified = (newObject) => {
    const index = objectChangedValues.findIndex(
      (item) => item.elementId === newObject.elementId
    );

    if (index !== -1) {
      objectChangedValues[index] = newObject;
    } else {
      objectChangedValues.push(newObject);
    }
  };

  return (
    <Card>
      <CardHeader color="info" icon>
        <CardIcon color="info">
          <AssignmentTurnedInIcon />
        </CardIcon>
      </CardHeader>
      <CardBody>
        <Form>
          {loadingElementsList ? (
            <LoadingCircleView />
          ) : (
            <GridContainer justify="center">
              <GridItem xs={12} style={{ marginBottom: 16 }}>
                <GridContainer alignItems="center">
                  {/* Back button - left */}
                  <GridItem
                    xs={12}
                    sm={3}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <ButtonComponent
                      simple
                      size="lg"
                      color="info"
                      onClick={history.goBack}
                    >
                      <ArrowBackIcon />
                      <span>{t("processRelationship.back")}</span>
                    </ButtonComponent>
                  </GridItem>
                  {/* Title - center */}
                  <GridItem
                    xs={12}
                    sm={6}
                    style={{
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <h3 style={{ margin: 0 }}>{processRelationshipName}</h3>
                  </GridItem>
                  <GridItem xs={12} sm={3}>
                    <GridContainer
                      justify="flex-end"
                      alignItems="center"
                      style={{ marginBottom: 16 }}
                    >
                      <Button
                        justIcon={true}
                        color="info"
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={handleClick}
                      >
                        <Tooltip
                          title={t(
                            "processRelationship.tooltip.downloadTemplate"
                          )}
                        >
                          <GetAppIcon />
                        </Tooltip>
                      </Button>
                      <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                      >
                        <MenuItem
                          onClick={() => {
                            const headers = ["_id", "element", "user", "tags"];
                            const { relations } = values;

                            const elementReducer = elementsList.reduce(
                              (acc, element) => {
                                const relation = relations.find(
                                  (relation) =>
                                    relation.elementId.toString() ===
                                    element._id.toString()
                                );
                                if (relation) {
                                  const user = usersMobile.find(
                                    (user) =>
                                      user._id.toString() ===
                                      relation?.userId?.toString()
                                  );

                                  acc.push({
                                    _id: element._id,
                                    value: element.value,
                                    user: user ? user.email : "",
                                    tag: relation.tags.join(",") || "",
                                  });
                                } else {
                                  acc.push({
                                    _id: element._id,
                                    value: element.value,
                                    user: "",
                                    tag: "",
                                  });
                                }
                                return acc;
                              },
                              []
                            );

                            const elements = elementReducer.map((element) => [
                              `"${element._id}"`,
                              `"${element.value}"`,
                              `"${element.user}"`,
                              `"${element.tag}"`,
                            ]);
                            let csvContent = [headers, ...elements]
                              .map((e) => e.join(","))
                              .join("\n");
                            const blob = new Blob([csvContent], {
                              type: "text/csv;charset=utf-8;",
                            });
                            const link = document.createElement("a");
                            link.setAttribute(
                              "href",
                              URL.createObjectURL(blob)
                            );
                            link.setAttribute(
                              "download",
                              "elements_template.csv"
                            );
                            document.body.appendChild(link); // Required for FF
                            link.click();
                            handleClose();
                          }}
                        >
                          {t("processRelationship.tooltip.downloadElement")}
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            const headers = ["_id", "element", "user", "tags"];
                            const elements = elementsList.map((element) => [
                              `"${element._id}"`,
                              `"${element.value}"`,
                              "",
                              "",
                            ]);

                            let csvContent = [headers, ...elements]
                              .map((e) => e.join(","))
                              .join("\n");

                            const blob = new Blob([csvContent], {
                              type: "text/csv;charset=utf-8;",
                            });
                            const link = document.createElement("a");
                            link.setAttribute(
                              "href",
                              URL.createObjectURL(blob)
                            );
                            link.setAttribute(
                              "download",
                              "elements_template.csv"
                            );
                            document.body.appendChild(link); // Required for FF

                            link.click();
                            handleClose();
                          }}
                        >
                          {t("processRelationship.tooltip.downloadTemplate")}
                        </MenuItem>
                      </Menu>
                      <input
                        id="csv-elements-import"
                        type="file"
                        accept=".csv"
                        style={{ display: "none" }}
                        onChange={async (e) => {
                          // const file = e.target.files[0];
                          // if (!file) return;
                          // const text = await file.text();
                          // const parsed = Papa.parse(text, {
                          //   header: true,
                          //   skipEmptyLines: true,
                          // });
                          // const data = parsed.data;
                          // try {
                          //   // Mapeo a relaciones
                          //   const newRelations = data.map((item) => {
                          //     // Buscar el usuario por email
                          //     const user = usersMobile.find(
                          //       (u) =>
                          //         u.email.toLowerCase() ===
                          //         item.user.toLowerCase()
                          //     );
                          //     return {
                          //       elementId: item._id,
                          //       label: item.element,
                          //       userId: user ? user._id : undefined,
                          //       tags: item.tags
                          //         ? item.tags
                          //             .split(",")
                          //             .map((tag) => tag.trim())
                          //             .filter(Boolean)
                          //         : [],
                          //     };
                          //   });

                          //   const currentTags = uniq(
                          //     flatten(
                          //       newRelations.map((relation) => relation.tags)
                          //     )
                          //   );

                          //   setFieldValue("relations", newRelations);
                          //   setFieldValue("currentTags", currentTags);
                          // } catch (error) {
                          //   console.error("Error processing CSV:", error);
                          //   return;
                          // }
                        }}
                      />
                      <Button
                        justIcon={true}
                        color="info"
                        onClick={() => {
                          document
                            .getElementById("csv-elements-import")
                            .click();
                        }}
                      >
                        <Tooltip
                          title={t("processRelationship.tooltip.upload")}
                        >
                          <PublishIcon />
                        </Tooltip>
                      </Button>
                      <Button
                        justIcon={true}
                        color="info"
                        onClick={() => {
                          //document.getElementById("csv-elements-import").click();

                          if (objectChangedValues.length > 0) {
                            setOpen(true);
                          } else {
                            saveUseersAssigned({
                              ...values,
                            });
                          }
                        }}
                      >
                        <Tooltip
                          title={t("processRelationship.forms.buttons.save")}
                        >
                          <SaveIcon />
                        </Tooltip>
                      </Button>
                    </GridContainer>
                  </GridItem>
                </GridContainer>
              </GridItem>

              <GridItem xs={12}>
                <ReactTable
                  data={elementsList.map((element) => {
                    const relation = values.relations.find(
                      (rel) =>
                        rel.elementId?.toString() === element._id?.toString()
                    );
                    return {
                      ...element,
                      user: relation ? relation.userId : "",
                      tag: relation ? relation.tags : [],
                    };
                  })}
                  columns={columns}
                  pageSizeOptions={optionsPagination}
                  showPaginationTop={true}
                  showPaginationBottom={false}
                  className="-striped -highlight"
                  resizable={false}
                  style={{
                    //maxHeight: "450px",
                    overflowY: "scroll",
                  }}
                  previousText={t(
                    "processRelationship.list.pagination.previousText"
                  )}
                  nextText={t("processRelationship.list.pagination.nextText")}
                  pageText={t("processRelationship.list.pagination.pageText")}
                  ofText={t("processRelationship.list.pagination.ofText")}
                  rowsText={t("processRelationship.list.pagination.rowsText")}
                  defaultFilterMethod={(filter, row) =>
                    filterElement(filter, row)
                  }
                />
              </GridItem>
            </GridContainer>
          )}
        </Form>
      </CardBody>

      <ObjectEditConfirmationModal
        open={open}
        setOpen={setOpen}
        objectChangedValues={objectChangedValues}
        handleSubmit={() => {
          saveUseersAssigned({
            ...values,
          });
        }}
      />
    </Card>
  );
};

const UserAssignedFormik = withFormik({
  enableReinitialize: true,
  mapPropsToValues: (props) => {
    const { assignedUsers } = props;

    return {
      relations: assignedUsers || [],
      currentTags: uniq(
        flatten(assignedUsers.map((relation) => relation.tags))
      ),
      //roleName: initialValues?.roleName || "",
    };
  },
  // handleSubmit: (values, { props }) => {
  //   props.updateValues({
  //     ...values,
  //     relations: values.relations.filter((relation) => relation.userId),
  //   });
  // },
})(UsersAssginedView);

export default UserAssignedFormik;
